import { render } from "./MySideBarTeacher.vue?vue&type=template&id=73a52a9c"
import script from "./MySideBarTeacher.vue?vue&type=script&lang=js"
export * from "./MySideBarTeacher.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__